import { useEffect } from 'react';
import { useSearchParams } from 'react-router';

import { parseAssetLibraryTypeFilterFromSearchParam } from '../assetLibraryFilters';
import { useStore } from '../assetLibraryStore';

/** Applies `?type=` from the library page URL to the asset library. */
export function useAssetLibraryUrlTypeFilter(enabled: boolean) {
  const store = useStore();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    if (!enabled) {
      return;
    }

    const typeFilter = parseAssetLibraryTypeFilterFromSearchParam(
      searchParams.get('type'),
    );

    if (typeFilter && typeFilter !== 'all') {
      store.setTypeFilter(typeFilter);
    }
  }, [enabled, searchParams, store]);
}
